// @flow
/**
 * @module Reducers/Workflows
 * @desc Workflows Reducer
 */

import { handleActions } from 'redux-actions';
import { WorkflowConstants } from 'constants/workflowConstants';
import { requestPending, requestSuccess, requestFail } from 'components/Request';

const initialState = {
};

export default handleActions({
  [WorkflowConstants.SAVE_LOAN_DETAILS]: (state, action) => ({
    ...state,
    loanDetails: action.payload,
  }),

  [requestPending(WorkflowConstants.START_ACTION)]: (state) => ({
    ...state,
  }),
  [requestSuccess(WorkflowConstants.START_ACTION)]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
  [requestFail(WorkflowConstants.START_ACTION)]: (state, action) => ({
    ...state,
    error: action.payload,
  }),

  [requestPending(WorkflowConstants.NEXT_ACTION)]: (state) => ({
    ...state,
  }),
  [requestSuccess(WorkflowConstants.NEXT_ACTION)]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
  [requestFail(WorkflowConstants.NEXT_ACTION)]: (state, action) => ({
    ...state,
    error: action.payload,
  }),

  [requestPending(WorkflowConstants.CHECKIN_ACTION)]: (state) => ({
    ...state,
  }),
  [requestSuccess(WorkflowConstants.CHECKIN_ACTION)]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
  [requestFail(WorkflowConstants.CHECKIN_ACTION)]: (state, action) => ({
    ...state,
    error: action.payload,
  }),

  [requestPending(WorkflowConstants.BACK_ACTION)]: (state) => ({
    ...state,
  }),
  [requestSuccess(WorkflowConstants.BACK_ACTION)]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
  [requestFail(WorkflowConstants.BACK_ACTION)]: (state, action) => ({
    ...state,
    error: action.payload,
  }),

  [requestPending(WorkflowConstants.RESUME_APPLICATION)]: (state) => ({
    ...state,
  }),
  [requestSuccess(WorkflowConstants.RESUME_APPLICATION)]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
  [requestFail(WorkflowConstants.RESUME_APPLICATION)]: (state, action) => ({
    ...state,
    error: action.payload,
  }),

  [requestPending(WorkflowConstants.REDIRECT_ACTION)]: (state) => ({
    ...state,
  }),
  [requestSuccess(WorkflowConstants.REDIRECT_ACTION)]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
  [requestFail(WorkflowConstants.REDIRECT_ACTION)]: (state, action) => ({
    ...state,
    error: action.payload,
  }),

  [requestPending(WorkflowConstants.GET_REDIRECT_DATA_ACTION)]: (state) => ({
    ...state,
  }),
  [requestSuccess(WorkflowConstants.GET_REDIRECT_DATA_ACTION)]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
  [requestFail(WorkflowConstants.GET_REDIRECT_DATA_ACTION)]: (state, action) => ({
    ...state,
    error: action.payload,
  }),
}, initialState);
